define('shared/initializer/form/adapters/Lead',[
    '$',
    '../constants',
    './Bootstrap3',
    './mixins/fields/AgeYoungerThanThirteen',
    './mixins/fields/Location',
    './mixins/fields/City',
    './mixins/fields/Country',
    './mixins/fields/SortedCountry',
    './mixins/fields/Telephone',
    './mixins/fields/Email',
    './mixins/fields/DynamicSubscribe',
    './mixins/ExistingMemberRedirectable',
    './mixins/ConversionTrackable',
    './mixins/ThrobberOnBeforeSubmit',
    './mixins/LabelFloatable',
    './mixins/EtagTrackable',
    './mixins/Ajaxable',
    './mixins/SubmissionLockable',
    './mixins/Templatable',
    './mixins/Empty',
    './mixins/InputValuePersistable',
    './mixins/AfterSubmitActionTriggerable',
    './mixins/LeadAfterSubmit',
    './mixins/Redirectable',
    './mixins/LPOnLoadDataDispatchable',
    './mixins/LeadConfigurable',
    './mixins/LeadCommon',
    './mixins/ClientIdTracking',
    'shared/lib/ctor'
],
function (
    $,
    constants,
    Bootstrap3Adapter,
    AgeYoungerThanThirteenField,
    LocationField,
    CityField,
    CountryField,
    SortedCountryField,
    TelephoneField,
    EmailField,
    DynamicSubscribeField,
    ExistingMemberRedirectable,
    ConversionTrackable,
    ThrobberOnBeforeSubmit,
    LabelFloatable,
    EtagTrackable,
    Ajaxable,
    SubmissionLockable,
    Templatable,
    EmptyMixin,
    InputValuePersistable,
    AfterSubmitActionTriggerable,
    LeadAfterSubmit,
    Redirectable,
    LPOnLoadDataDispatchable,
    LeadConfigurable,
    LeadCommon,
    ClientIdTracking,
    ctor
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.configs = {
            redirectable: {
                backgroundRedirectWhenSkipped: true,
                url: '/etc/designs/b2c/others/form-default-thankyou'
            }
        };
        me.base.apply(me, arguments);
        me.mixin(
            LPOnLoadDataDispatchable,
            AgeYoungerThanThirteenField,
            LocationField,
            CityField,
            CountryField,
            SortedCountryField,
            TelephoneField,
            EmailField,
            DynamicSubscribeField,
            ThrobberOnBeforeSubmit,
            LabelFloatable,
            EtagTrackable,
            Ajaxable,
            SubmissionLockable,
            me.options.enableGenericField ? Templatable: EmptyMixin,
            InputValuePersistable,
            ConversionTrackable,
            LeadAfterSubmit,
            ExistingMemberRedirectable,
            LeadConfigurable,
            LeadCommon,
            ClientIdTracking,

            AfterSubmitActionTriggerable, // Redirectable must follows immediately
            Redirectable
        );

    }).inherit(Bootstrap3Adapter);

    return Ctor;
});

